import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import { Layout, Spin } from 'antd';
import Cookies from 'js-cookie';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import values from 'lodash/values';
import "./style.css";
import SiderComponent from '../../common/SiderComponent';
import { COMPONENT_ROUTE_MAP } from '../../../constants/index';
import { clearUser, setUser } from '../../../helpers/userSlice';
import { fetchData } from '../../../services/HomeService';
import { showErrorMessage } from '../../../utils';
import '../../vendor/vendor-list/style.css';
import '../../vendor/vendor-add/style.css';
import '../../vendor/vendor-profile/style.css';
import '../../vendor/vendor-tasks/style.css';
import '../../vendor/vendor-explore/style.css';
import '../../vendor/vendor-approval/style.css';
import '../../vendor/vendor-subscription/style.css';
import '../../vendor/vendor-quotations/style.css';
import '../../vendor/vendor-quotations/style.css';
import '../../account/style.css';
import '../../enterprise-data/style.css';
import '../../dashboard/dashboard-overall/style.css';



const { Content } = Layout;

const VendorOnboard = lazy(() => import('../../vendor/vendor-add/index'));
const VendorLists = lazy(() => import('../../vendor/vendor-list'));
const VendorProfile = lazy(() => import('../../vendor/vendor-profile'));
const VendorTasks = lazy(() => import('../../vendor/vendor-tasks'));
const VendorRank = lazy(() => import('../../feature/VendorRank'));
const VendorDiscover = lazy(() => import('../../feature/VendorDiscover'));
const AccountInfo = lazy(() => import('../../account'));
const EnterpriseData = lazy(() => import('../../enterprise-data'));
const DashboardOverall = lazy(() => import('../../dashboard/dashboard-overall'));
const VendorSubscriptionPlans = lazy(() => import('../../vendor/vendor-subscription'));
const VendorQuotations = lazy(() => import('../../vendor/vendor-quotations'));
const VendorListQuotes = lazy(() => import('../../vendor/vendor-quotations/VendorListQuotes'));
const VendorApprovals = lazy(() => import('../../vendor/vendor-approval'));
const VendorExplore = lazy(() => import('../../vendor/vendor-explore'));
const ProfileEdit = lazy(() => import('../../profile/index'));
const ProductListing = lazy(() => import('../../product-listing/index'));

const Sidebar = ({ items, getIcon, orgType, verified, step, AvatarColor, ComponentConfig }) => {
    const { type, subtype } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.user);

    const [collapsed, setCollapsed] = useState(false);
    const [selectedParent, setSelectedParent] = useState('');
    const [selectedChild, setSelectedChild] = useState('');
    const intervalDurationRef = useRef(20 * 1000);

    const sessionStatus = async () => {
        const resp = await fetchData('/users/session/status');
        if (!resp.success) {
            showErrorMessage('Invalid session- Try Logging again!!');
            await logout();
        } else {
            console.log('Session Check Successful!!');
        }
    };

    const logout = async () => {
        const resp = await fetchData('/users/auth/logout');
        if (resp.success) {
            dispatch(clearUser());
            navigate('/login');
        }
    };

    useEffect(() => {
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) {
                intervalDurationRef.current = 20 * 1000;
            } else {
                intervalDurationRef.current = 0;
            }
        });
    }, []);

    useEffect(() => {
        let intervalId;
        if (intervalDurationRef.current) {
            intervalId = setInterval(() => {
                console.log('Session-Call-', intervalDurationRef.current);
                sessionStatus();
                intervalDurationRef.current = intervalDurationRef.current + 1 * 60 * 1000;
            }, intervalDurationRef.current);
        }

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        const userCookie = Cookies.get("userInfo");
        if (userCookie) {
            console.log('Setting user with cookies and state');
            const userInfo = JSON.parse(userCookie);
            dispatch(setUser({ ...userInfo, ...userData }));
        }
        if (!type && !(orgType && (verified === 'true'))) {
            if (userCookie) {
                console.log('Setting user with cookies');
                const userInfo = JSON.parse(userCookie);
                dispatch(setUser({ ...userInfo }));
            }
            navigate(`/login?type=selection&org_type=${orgType}&verified=${verified}&step=${step}`);
        } else if (!type || !values(COMPONENT_ROUTE_MAP).includes(type)) {
            navigate(`/home/${COMPONENT_ROUTE_MAP['DashboardOverall']}`);
        }
    }, [type, navigate]);

    const handleCollapse = (collapsed) => {
        setCollapsed(collapsed);
    };

    const handleBreadCrumb = (child, parent) => {
        setSelectedChild(child);
        setSelectedParent(parent);
    };

    console.log('Sidebar component rendered');

    return (
        <>
            <Layout style={{ minHeight: 'calc(100vh - 86px)', zIndex: "-1", boxShadow: " 0px 2px 8px rgba(0, 0, 0, 0.15)", marginTop: "1px" }}>
                <SiderComponent items={items} getIcon={getIcon} handleCollapse={handleCollapse} collapsed={collapsed} onMenuItemSelect={handleBreadCrumb} />
                <Layout>
                    <Content style={{ margin: '4px', backgroundColor: '#F5F5F5' }}>
                        <Suspense fallback={<Spin size="large" />}>
                            {type === COMPONENT_ROUTE_MAP['DashboardOverall'] && <DashboardOverall selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} ComponentConfig={ComponentConfig} />}
                            {type === COMPONENT_ROUTE_MAP['VendorOnboard'] && <VendorOnboard selectedParent={selectedParent} selectedChild={selectedChild} />}
                            {type === COMPONENT_ROUTE_MAP['VendorLists'] && <VendorLists selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} />}
                            {type === COMPONENT_ROUTE_MAP['VendorProfile'] && <VendorProfile selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} />}
                            {type === COMPONENT_ROUTE_MAP['VendorTasks'] && <VendorTasks selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} />}
                            {type === COMPONENT_ROUTE_MAP['EnterpriseData'] && <EnterpriseData selectedParent={selectedParent} selectedChild={selectedChild} />}
                            {type === COMPONENT_ROUTE_MAP['VendorRank'] && <VendorRank selectedParent={selectedParent} selectedChild={selectedChild} />}
                            {type === COMPONENT_ROUTE_MAP['VendorDiscover'] && <VendorDiscover selectedParent={selectedParent} selectedChild={selectedChild} type={type} />}
                            {type === COMPONENT_ROUTE_MAP['VendorExplore'] && <VendorExplore selectedParent={selectedParent} selectedChild={selectedChild} />}
                            {type === COMPONENT_ROUTE_MAP['AccountInfo'] && <AccountInfo selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} />}
                            {type === COMPONENT_ROUTE_MAP['VendorSubscriptionPlans'] && <VendorSubscriptionPlans selectedParent={selectedParent} selectedChild={selectedChild} />}
                            {type === COMPONENT_ROUTE_MAP['VendorQuotations'] && subtype !== COMPONENT_ROUTE_MAP['Vendors'] && <VendorQuotations selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} ComponentConfig={ComponentConfig} />}
                            {type === 'quotations' && subtype === 'vendors' && <VendorListQuotes selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} ComponentConfig={ComponentConfig} />}
                            {type === COMPONENT_ROUTE_MAP['VendorApprovals'] && <VendorApprovals selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} ComponentConfig={ComponentConfig} />}
                            {type === COMPONENT_ROUTE_MAP['ProfileEdit'] && <ProfileEdit selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} ComponentConfig={ComponentConfig} />}
                            {type === COMPONENT_ROUTE_MAP['ProductSKU'] && <ProductListing selectedParent={selectedParent} selectedChild={selectedChild} AvatarColor={AvatarColor} />}
                        </Suspense>
                    </Content>
                </Layout>
            </Layout>
        </>
    );
};

export default Sidebar;